import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ExchangeOfficeProcess from './ExchangeOfficeProcess';
import SolutionCenterProcess from './SolutionCenterProcess';
import { getUserRole } from 'src/utils/Common';
import { getUser } from 'src/utils/Common';
import { useSelector } from 'react-redux';
import { getTotalDayOfExchangeVoucher } from 'src/store/slices/generalFollowSlice';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  div: {
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%',
    color: 'red'
  }
}));

function ApprovalProcess() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();
  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const receiptStatus = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  )[0]?.Exchange?.Status;

  const [expandedConfirm, setExpandedConfirm] = React.useState(true);
  const [totalDayOfExchangeVoucher, setTotalDayOfExchangeVoucher] =
    React.useState([]);

  const userRole = getUserRole().Component;

  const handleToggleCollapse = () => {
    setExpandedConfirm(!expandedConfirm);
  };

  // useEffect(() => {
  //   calculateTotalDayOfExchangeVoucher(invoiceData[0]?.Apply?.ReceiptNumber)
  // }, [])

  // const calculateTotalDayOfExchangeVoucher = (ReceiptNumber) => {
  //   dispatch(getTotalDayOfExchangeVoucher(ReceiptNumber)).then((response) => {
  //     if (response.payload?.length > 0) {
  //       setTotalDayOfExchangeVoucher(response.payload[0].TOPLAM_GUN_SAYISI);
  //     }
  //   })
  // }

  return (
    <>
      <Card
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#f5f5f5',
          boxShadow: 'none'
        }}
      >
        <CardHeader
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: '12px',
            padding: '12px 16px',
            '& .MuiCardHeader-title': {
              fontSize: '12px',
              fontWeight: 500
            }
          }}
          avatar={
            <DragIndicatorIcon sx={{ color: '#FF9800', fontSize: '20px' }} />
          }
          action={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {invoiceData[0]?.Consumer.UpTypeId == 7 &&
              invoiceData[0]?.Exchange.GPSNO != 0 &&
              receiptStatus === 31 ? (
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '12px',
                    color: '#d32f2f',
                    mr: 1
                  }}
                >
                  {'Değişim Çeki ' +
                    invoiceData[0]?.Exchange?.TotalDayOfWebPoint +
                    ' Gün Önce Tanımlanmıştır.'}
                </Typography>
              ) : null}
              <Tooltip title={expandedConfirm ? 'Daralt' : 'Genişlet'}>
                <IconButton
                  onClick={handleToggleCollapse}
                  sx={{ color: '#FF9800' }}
                >
                  {expandedConfirm ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          }
          title="Onay İptal İşlemleri"
        />
        <Collapse in={expandedConfirm} timeout="auto" unmountOnExit>
          <CardContent
            sx={{
              padding: '16px',
              backgroundColor: '#fff',
              borderRadius: '0 0 12px 12px'
            }}
          >
            {<SolutionCenterProcess />}
            {userRole?.filter(
              (i) => i.COMPONENT_NAME == 'ExchangeOfficeProcess'
            ).length > 0 ? (
              <ExchangeOfficeProcess />
            ) : null}
          </CardContent>
        </Collapse>
      </Card>
    </>
  );
}

export default ApprovalProcess;
